import { NgModule, ModuleWithProviders } from '@angular/core';
import { StpAppModule } from '../stp/stp-app/stp-app.module';
import { StpAppMaterialModule } from '../stp/stp-app-material/stp-app-material.module';
import { CommonModule } from '@angular/common';
import { SnackbarService } from './services/snackbar.service';
import { ReactiveFormsModule } from '@angular/forms';
import { UrlService } from './services/url.service';
import { RouteParamService } from './services/route-param.service';
import { ModalHelper } from './services/modal-helper.service';
import { CanDeactivateGuard } from './guard/can-deactivate.guard'
import { FormFieldValidationService } from './services/form-field-validation.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    StpAppModule,
    StpAppMaterialModule
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    StpAppModule,
    StpAppMaterialModule
  ],
  declarations: [],
  providers: [
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        ModalHelper,
        FormFieldValidationService,
        RouteParamService,
        SnackbarService,
        UrlService,
        CanDeactivateGuard
      ]
    };
  }
 }
